import { render, staticRenderFns } from "./li_loading.vue?vue&type=template&id=4c364206&scoped=true"
import script from "./li_loading.vue?vue&type=script&lang=js"
export * from "./li_loading.vue?vue&type=script&lang=js"
import style0 from "./li_loading.vue?vue&type=style&index=0&id=4c364206&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c364206",
  null
  
)

export default component.exports